import { z } from 'zod';

export const PAYMENT_GATEWAYS = ['WORLDLINE', 'STRIPE', 'FAT_ZEBRA', 'LINKLY'] as const;
export const zPaymentGateway = z.literal(PAYMENT_GATEWAYS);
export type PaymentGateway = z.infer<typeof zPaymentGateway>;

export const PAYMENT_METHOD_IDS = ['APPLE_PAY', 'GOOGLE_PAY'] as const;
export const zPaymentMethodId = z.literal(PAYMENT_METHOD_IDS);
export type PaymentMethodId = z.infer<typeof zPaymentMethodId>;

export const zStage = z.literal(['dev', 'staging', 'production']);
export type Stage = z.infer<typeof zStage>;

export const zLogLevel = z.literal(['DEBUG', 'INFO', 'WARN', 'ERROR']);
export type LogLevel = z.infer<typeof zLogLevel>;
